import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonils = () => {
  // Custom arrow components that handle the props correctly
  const CustomNextArrow = ({ currentSlide, slideCount, ...props }) => (
    <button 
      className="testimonial-next-arrow" 
      onClick={props.onClick}
      style={{ display: currentSlide === slideCount - 1 ? 'none' : 'block' }}
    >
      <i className="fa-solid fa-arrow-right"></i>
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: null,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <>
      {/* TESTIMONIALS START */}
      <div className="testimonial sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700">
                  <img src="/assets/img/icons/span1.png" alt="" /> Testimonials
                </span>
                <h2 className="title tg-element-title">
                  Discover What Our Clients Have <br /> To Say About Us
                </h2>
              </div>
            </div>
          </div>

          <div className="row _relative">
            <Slider {...settings} className="tes1-slider" data-aos="fade-up" data-aos-duration="800">
              <div className="tes1-single-slider">
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <div className="right-side">
                      <h4>What Our Clients Are Saying</h4>
                      <p>
                        "As a fintech company which handles payments across borders, it's really important to have access to correct and up-to-date currency rates. IBRLIVE API has made our work easier, cut down on mistakes, and earned our clients' trust. "The integration went off without a hitch, and the support is great."
                      </p>
                      <div className="bottom-area">
                        <div className="img">
                          <img src="/assets/img/testimonial/tes1-smoll-img.webp" alt="" />
                        </div>
                        <div className="heading">
                          <h5>Rohit Mehra,</h5>
                          <p>founder</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {/* <div className="left-side">
                      <img src="/assets/img/testimonial/tes1-big-img.png" alt="" />
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="tes1-single-slider">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="right-side">
                      <h4>What Our Clients Are Saying</h4>
                      <p>
                        "Our online store sells to people all around the world, therefore we needed a means to show prices in different currencies that we could trust. It was easy to do with the IBRLIVE's Exchange Rate API in only a few lines of code. "It works quickly and accurately, and it has helped us get more sales."
                      </p>
                      <div className="bottom-area">
                        <div className="img">
                          <img src="/assets/img/testimonial/tes1-smoll-img.webp" alt="" />
                        </div>
                        <div className="heading">
                          <h5>Ananya Iyer,</h5>
                          <p>Co-Founder</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {/* <div className="left-side">
                      <img src="/assets/img/testimonial/tes1-big-img.png" alt="" />
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="tes1-single-slider">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="right-side">
                      <h4>What Our Clients Are Saying</h4>
                      <p>
                        "As a developer, I've used a lot of APIs, but the one from IBRLIVE stands out since its documentation is clear and it responds quickly. I added it to a client's app in less than an hour. The real-time currency data is very reliable, therefore this is my go-to API for exchange rates."
                      </p>
                      <div className="bottom-area">
                        <div className="img">
                          <img src="/assets/img/testimonial/tes1-smoll-img.webp" alt="" />
                        </div>
                        <div className="heading">
                          <h5>Michael Johnson,</h5>
                          <p>A freelance developer in New York</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {/* <div className="left-side">
                      <img src="/assets/img/testimonial/tes1-big-img.png" alt="" />
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="tes1-single-slider">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="right-side">
                      <h4>What Our Clients Are Saying</h4>
                      <p>
                        "It was always hard for us to maintain track of fiat-to-crypto rates for our crypto exchange. IBRLIVE API gives us real-time updates and clear rates, which has made users feel more confident. "Highly recommended for anyone who works in crypto or foreign exchange."
                      </p>
                      <div className="bottom-area">
                        <div className="img">
                          <img src="/assets/img/testimonial/tes1-smoll-img.webp" alt="" />
                        </div>
                        <div className="heading">
                          <h5>Kunal Sharma,</h5>
                          <p>CTO</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {/* <div className="left-side">
                      <img src="/assets/img/testimonial/tes1-big-img.png" alt="" />
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="tes1-single-slider">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="right-side">
                      <h4>What Our Clients Are Saying</h4>
                      <p>
                        "We help firms manage their foreign exchange risk, and accuracy is key. IBRLIVE API has changed the game. It gives you real-time data, is always online, and includes easy-to-understand documentation. "It really makes our consulting services better."
                      </p>
                      <div className="bottom-area">
                        <div className="img">
                          <img src="/assets/img/testimonial/tes1-smoll-img.webp" alt="" />
                        </div>
                        <div className="heading">
                          <h5>Emily Chen,</h5>
                          <p>Managing Partner</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    {/* <div className="left-side">
                      <img src="/assets/img/testimonial/tes1-big-img.png" alt="" />
                    </div> */}
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
      {/* TESTIMONIALS END */}
    </>
  );
};

export default Testimonils;